module.exports = __webpack_public_path__ + "img/banner-header_03-empresas-y-corporativos.ce52ec9f.png";